import Vue from 'vue'

/**
 * Add class default color class according exercise current execution state
 * @name Exercise state class
 * @returns {*} Exercise state class
 */

const exerciseState = {
  inserted(el, binding, vm) {
    const prefix = 'exercise-state-'
    const exercise = binding.value
    const state = vm.context.$filters.exerciseState(exercise)

    // Maintaining retro compatibility. Add here older prop values
    el.className += ` ${prefix}${state}`

    return true
  },
}

Vue.directive('exerciseState', exerciseState)

export default exerciseState
